export const faqState = {
  faqFormStatus: false,
  faqIsEdit: false,
  faqSelectedForEdit: null,
  faqBackFromEditPage: false,
  faqPageCount : null,
  faqTableItems :null
};